import React from "react";
import {
  AppBadge,
  AppButton,
  AppCard,
  AppInput,
} from "./app-ui.js";

export const Card = (props) => <AppCard {...props} />;
export const Button = (props) => <AppButton {...props} />;
export const Input = (props) => <AppInput {...props} />;
export const Badge = (props) => <AppBadge {...props} />;
